// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3wPWi","productName":"Table_productName__IQ4Ms"};